import { RemiAvatar } from "@remi/next-ui";

import { usePersonProfilePhotos } from "~/hooks/usePerson";

type GroupTooltipProps = {
  personIds: string[];
};

export const GroupTooltipContent = ({ personIds }: GroupTooltipProps) => {
  const { data: personsWithPhotos } = usePersonProfilePhotos(personIds);

  return (
    <div className="flex min-w-64 max-w-64 flex-col gap-1 p-4">
      {personsWithPhotos.map((person) => (
        <span className="flex items-center gap-1.5" key={person.id}>
          <RemiAvatar size="sm" person={person} url={person.profilePhotoUrl} />
          <span className="font-medium text-text-primary text-xs">{person.contact.name}</span>
        </span>
      ))}
    </div>
  );
};
